import { render, staticRenderFns } from "./TreeList.vue?vue&type=template&id=b963120a&"
import script from "./TreeList.vue?vue&type=script&lang=js&"
export * from "./TreeList.vue?vue&type=script&lang=js&"
import style0 from "./TreeList.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports